export default __webpack_public_path__ + "static/media/juego2_perder.7d079806.png";